// @flow
import { Group, List, Text } from '@mantine/core'
import * as React from 'react'

import * as DisplayData from '@/components/commons/DisplayData'
import { SimplePayment as SimplePaymentType } from '@/types'

interface Props {
  payments: SimplePaymentType[]
}

export default function PaymentsCalendar({ payments }: Props) {
  return <List listStyleType="none">
    {payments.length > 0 &&
    payments.map((payment:SimplePaymentType, index:number) => (
      <List.Item mb="xs" key={payment.displayName} pt="sm" sx={{ borderTop: '1px solid #CCCCCC' }}>
        <Text size="sm">{payment.displayName}</Text>
        <Group position="apart">
          <Text size="sm">
              Será cobrado em{' '}
            <Text size="sm" component="span" color="custom">
              <strong>
                <DisplayData.DateField type="date" value={payment.dueDate} />
              </strong>
            </Text>
          </Text>
          <Text size="sm" color="custom">
            <strong>
              <DisplayData.CurrencyField
                zeroText="-"
                value={Number(payment.total || payment.amount)}
              />
            </strong>
          </Text>
        </Group>
      </List.Item>
    ))}
  </List>
}
